import React from 'react';
import classnames from 'classnames';

import { sendAnalyticsEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import SmartImage from 'dpl/components/SmartImage';
import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import { BUYER_APP_STORE_URL } from 'dpl/shared/constants/urls';

import engagementPhoneWallpaper from 'dpl/assets/engagement_phone_wallpaper.png';

import Button, { BUTTON_VARIANTS, BUTTON_SIZES } from '../design_system/Button';
import MessagePreview, { MessagePreviewProps } from './MessagePreview';

interface AppEngagementMobileMenuAnalytics {
  view: string;
  view_feature_location: string;
  buyer_profile_id?: number | string;
  conversation_id?: number | string;
}

interface AppEngagementMobileMenuProps {
  title: string;
  subtitle: string;
  isOpen: boolean;
  onCloseClick: () => void;
  messagePreviewProps: MessagePreviewProps;
  analytics: AppEngagementMobileMenuAnalytics;
}

export default function AppEngagementMobileMenu({
  title,
  subtitle,
  isOpen,
  onCloseClick,
  messagePreviewProps,
  analytics
}: AppEngagementMobileMenuProps) {
  function handleButtonClick(
    buttonCta: string,
    e: React.MouseEvent<HTMLElement>
  ) {
    e.stopPropagation();

    sendAnalyticsEvent(ANALYTICS_EVENTS.APP_PROMPT_INTERACTION_BY_USER, {
      button_cta: buttonCta,
      ...analytics,
      view_feature: ANALYTICS_VIEW_FEATURES.APP_DOWNLOAD_MODAL
    });
    onCloseClick();
  }

  return (
    <FixedTooltipPortal
      className="AppEngagementMobileMenu bg-white ph5 pt8"
      isVisible={isOpen}
      onCloseClick={onCloseClick}
      shouldHideCloseButton
    >
      <div className="tc pb6">
        <h4 className="font-24 lh-title">{title}</h4>
        <p className="mt2 font-16 secondary">{subtitle}</p>
      </div>
      <div className="AppEngagementMobileMenu__phone-frame mh3 flex relative overflow-hidden bt bl br b--stone-700">
        <SmartImage className="w-100" src={engagementPhoneWallpaper} />
        <div className="AppEngagementMobileMenu__message-preview absolute left-0 right-0 padding-h-10">
          <MessagePreview {...messagePreviewProps} />
        </div>
      </div>
      <div className="flex flex-column gap-8 pt4 bt b--default font-16 nh5 ph5">
        <a
          className={classnames(
            'db no-underline lh-body',
            BUTTON_VARIANTS.primary,
            BUTTON_SIZES.small
          )}
          href={BUYER_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => handleButtonClick('Continue', e)}
        >
          Continue
        </a>
        <Button
          className="lh-body"
          size="small"
          variant="ghost"
          onClick={e => handleButtonClick('Stay in browser', e)}
        >
          Stay in browser
        </Button>
      </div>
    </FixedTooltipPortal>
  );
}
